/* eslint-disable react-hooks/exhaustive-deps */

import {
  I2cInput,
  I2cRadioButton,
  I2cRadioGroup,
  I2cCheckboxGroup,
  I2cListItem,
  I2cCheckbox,
  I2cButton,
  I2cPhoneField,
  I2cTabGroup,
  I2cTabPanel,
  I2cTab,
  I2cIcon,
} from "@webcomponents/i2cwebcomponents/dist/react";
import React, { useEffect, useState } from "react";
import "../Prepaid.scss";
import { useForm, useFieldArray, Controller } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as Yup from "yup";
import { emailAdressValidator } from "../../../Utils/stringUtls";

const CustomerServiceWebsite = ({
  setAddFormData,
  addFormData,
  setFormValidStates,
  formDataJson,
  isFetching,
}) => {
  const webRequire = ["Yes", "No", "N/A"];
  const agentWebsiteLang = [
    { label: "English", value: "english" },
    { label: "Spanish", value: "spanish" },
    { label: "Other", value: "other" },
  ];
  const [activeTab, setActiveTab] = useState(0);
  const generalErrorMessage = "Field is required"; 
 
  const validationSchema = Yup.object({
    ic_csw_web_agent_required: Yup.string()
      .required(generalErrorMessage)
      .min(1, generalErrorMessage),

    ic_csw_website_language: Yup.array().optional(),

    ic_csw_website_language_other: Yup.string().test(
      "website-language-other",
      generalErrorMessage,
      function (val) {
        const langs = this.parent.ic_csw_website_language || [];
        if (langs.includes("other")) {
          return !val || val.length > 0;
        }
        return true;
      }
    ), 
    users: Yup.array().of(
      Yup.object({
        iac_aw_name: Yup.string().nullable(),
        iac_aw_title: Yup.string().nullable(),
        iac_aw_phone: Yup.string().nullable(),
        iac_aw_cell: Yup.string().nullable(),
        iac_aw_email: Yup.string()
          .nullable()
          .test(
            "valid-email",
            "Invalid email address",
            (value) => !value || emailAdressValidator(value)
          ),
      })
    ).optional(),
  });
  const handleWebLangAdd = (event) => {
    let selectedCardAdditionalInfo;
    if (!event.length) selectedCardAdditionalInfo = event.target.value;
    else selectedCardAdditionalInfo = event;
    let updatedAdditionalInfo = [
      ...methods.getValues("ic_csw_website_language"),
    ];

    if (updatedAdditionalInfo.includes(selectedCardAdditionalInfo)) {
      // If the card is already selected, remove it
      updatedAdditionalInfo = updatedAdditionalInfo.filter(
        (card) => card !== selectedCardAdditionalInfo,
      );
    } else {
      // If the card is not selected, add it
      updatedAdditionalInfo.push(selectedCardAdditionalInfo);
    }

    if (!updatedAdditionalInfo.includes("other")) {
      methods.setValue("ic_csw_website_language_other", "");
    }
    methods.setValue("ic_csw_website_language", updatedAdditionalInfo);
    methods.trigger();
    handleValueChanges();
  };
  // Initialize React Hook Form with Yup resolver
  const methods = useForm({
    resolver: yupResolver(validationSchema),
    mode: "all",
    reValidateMode: "onChange",
    shouldUseNativeValidation: false,
    criteriaMode: "firstError",
    defaultValues: {
      ic_csw_web_agent_required: "",
      ic_csw_website_language: [],
      ic_csw_website_language_other: "",
      users: [
        {
          iac_aw_name: "",
          iac_aw_title: "",
          iac_aw_phone: "",
          iac_aw_phone_country: "",
          iac_aw_cell: "",
          iac_aw_cell_country: "",
          iac_aw_email: "",
        },
      ],
    },
  });

  // Controlls destructuring from the method
  const {
    control,
    formState: { errors },
  } = methods;
  const { fields, append, remove } = useFieldArray({
    control,
    name: "users", // Name of the array field in your form,
  });
  // Trigger validation when component mounts
  React.useEffect(() => {
    methods.trigger();
  }, [fields]);

  const handleValueChanges = () => {
    const values = methods.getValues();
    setAddFormData({
      ...addFormData,
      3: {
        ...addFormData["3"],
        "3_1": { ...values },
      },
    });
  };

  const formFields = [
    "users",
    "ic_csw_web_agent_required",
    "ic_csw_website_language",
    "ic_csw_website_language_other",
  ];

  useEffect(() => {
    if (!isFetching && Object.keys(formDataJson ?? {}).length) {
      formFields.forEach((field) => {
        methods.setValue(field, formDataJson[3]["3_1"][field] ?? "");
      });
      methods.trigger();
      handleValueChanges();
    }
  }, [isFetching]);

  // Update form validation state when errors change
  React.useEffect(() => {
    const errorsLength = Object.keys(errors).length;
    if (errorsLength === 0) setFormValidStates("3_1", true);
    else setFormValidStates("3_1", false);
    handleValueChanges();
  }, [Object.keys(errors).length]);

  return (
    <React.Fragment>
      <div className="forms-instance">
        <div className="section-space">
          <div className="sub-heading mb-16">
            Would you like i2c C-Agent Website?
          </div>
          <I2cRadioGroup
            onI2cChange={(e) => {
              methods.setValue("ic_csw_website_language", []);
              methods.setValue("ic_csw_website_language_other", "");
              methods.setValue("users", []);
              methods.setValue("ic_csw_web_agent_required", e.target.value);
              methods.trigger();
              handleValueChanges();
            }}
          >
            {webRequire.map((web, index) => (
              <I2cRadioButton
                key={index}
                name="ic_cAgent"
                checked={
                  methods.watch("ic_csw_web_agent_required") ===
                  web.toLocaleLowerCase()
                }
                value={web.toLocaleLowerCase()}
              >
                {web}
              </I2cRadioButton>
            ))}
          </I2cRadioGroup>
        </div>
        {methods.watch("ic_csw_web_agent_required") === "yes" && (
          <>
            <div className="section-space">
              <div className="sub-heading mb-16">C-Agent Website Language</div>
              <I2cCheckboxGroup>
                <div i2c-grid="grid gap-sm">
                  {agentWebsiteLang.map((web, index) => (
                    <I2cListItem
                      key={index}
                      i2c-grid="4@md"
                      variant="receipt"
                      label={web.label}
                      sublabel=""
                      value=""
                      type="checkbox"
                      checked={methods
                        .watch("ic_csw_website_language")
                        .includes(web.value)}
                      onI2cCheckboxClicked={(e) => handleWebLangAdd(web.value)}
                    >
                      <I2cCheckbox
                        slot="prefix"
                        name="ic_cAgentLang"
                        value={web.value}
                        label=""
                        filled
                        checked={methods
                          .watch("ic_csw_website_language")
                          .includes(web.value)}
                        // onI2cChange={(e) => handleWebLangAdd(e)}
                        className="customCheckbox"
                      ></I2cCheckbox>
                    </I2cListItem>
                  ))}
                </div>
              </I2cCheckboxGroup>
              {methods.watch("ic_csw_website_language").includes("other") && (
                <div i2c-grid="grid gap-sm" className="mt-16">
                  <div i2c-grid="4@md">
                    <div className="single-field-wrapper">
                      <Controller
                        name="ic_csw_website_language_other"
                        control={control}
                        render={({ field }) => (
                          <I2cInput
                            {...field}
                            className="single-input-field"
                            placeholder="Please Specify"
                            onI2cInput={(e) => {
                              const value = e.target.value;
                              field.onChange(value);
                              handleValueChanges();
                            }} 
                            size="large"
                            label="Enter Details"
                            name={"ic_csw_website_language_other"}
                          />
                        )}
                      />
                      {/* <ErrorMessage
                        show={
                          errors.ic_csw_website_language_other &&
                          methods.formState.touchedFields
                            .ic_csw_website_language_other
                            ? true
                            : false
                        }
                        message={
                          errors.ic_csw_website_language_other?.message ??
                          "Invalid input"
                        }
                      /> */}
                    </div>
                  </div>
                </div>
              )}
            </div>
            <div>
              <div className="sub-heading mb-4">User Details</div>
              <div className="custom-label-light mb-16">
                Please provide the email address, Name and Contact information
                of individuals who will require administrator access.
              </div>
              <I2cTabGroup placement="top" activation="manual" lineUnfilled>
                {fields.map((user, index) => (
                  <React.Fragment key={index}>
                    <I2cTab
                      active={index === activeTab}
                      onClick={(e) => setActiveTab(index)}
                      key={index + user.id}
                      slot="nav"
                      panel={index + 1}
                      lineUnfilled
                      className="user-tab"
                    >
                      User {index + 1}
                    </I2cTab>
                    <I2cTabPanel active={index === activeTab} name={index + 1}>
                      <div i2c-grid="grid gap-column-sm gap-row-md">
                        <div i2c-grid="4@md">
                          <Controller
                            name={"iac_aw_name" + index}
                            control={control}
                            render={({ field }) => (
                              <I2cInput
                                label="Name"
                                {...field}
                                name={"iac_aw_name" + index}
                                placeholder="Enter Name"
                                size="large"
                                value={
                                  methods.watch(`users`)[index]?.iac_aw_name
                                }

                                key={user.id} // important to include key with field's id
                                onI2cInput={(e) => {
                                  methods.setValue(
                                    `users.${index}.iac_aw_name`,
                                    e.target.value,
                                  );
                                  methods.trigger();
                                  handleValueChanges();
                                }}
                              />
                            )}
                          />
                          {/* {errors?.users?.length &&
                          methods.formState.touchedFields ? (
                            <ErrorMessage
                              show={
                                errors.users[index]?.iac_aw_name &&
                                methods.formState.touchedFields?.[
                                  "iac_aw_name" + index
                                ]
                                  ? true
                                  : false
                              }
                              message={
                                errors?.users[index]?.iac_aw_name?.message ??
                                "Invalid input"
                              }
                            />
                          ) : null} */}
                        </div>
                        <div i2c-grid="4@md">
                          <Controller
                            name={"iac_aw_title" + index}
                            control={control}
                            render={({ field }) => (
                              <I2cInput
                                label="Title"
                                {...field}
                                placeholder="Title"
                                name="iac_aw_title"
                                size="large"
                                value={
                                  methods.watch(`users`)[index]?.iac_aw_title
                                }

                                key={user.id} // important to include key with field's id
                                onI2cInput={(e) => {
                                  methods.setValue(
                                    `users.${index}.iac_aw_title`,
                                    e.target.value,
                                  );
                                  methods.trigger();
                                  handleValueChanges();
                                }}
                              />
                            )}
                          />
                          {/* {errors?.users?.length &&
                          methods.formState.touchedFields ? (
                            <ErrorMessage
                              show={
                                errors.users[index]?.iac_aw_title &&
                                methods.formState.touchedFields?.[
                                  "iac_aw_title" + index
                                ]
                                  ? true
                                  : false
                              }
                              message={
                                errors?.users[index]?.iac_aw_title?.message ??
                                "Invalid input"
                              }
                            />
                          ) : null} */}
                        </div>
                        <div i2c-grid="4@md">
                          <I2cPhoneField
                            format="NATIONAL"
                            show-flags
                            name="iac_aw_phone"
                            label="Phone Number"
                            size="large"
                            country-box
                            key={user.id} // important to include key with field's id
                            onI2cChange={(e) => {
                              const country = e.target.country;
                              const isValid = e.target.isValid;
                              const value = e.target.value;
                              methods.setValue(
                                `users.${index}.iac_aw_phone_country`,
                                country,
                              );
                              methods.setValue(
                                `users.${index}.iac_aw_phone`,
                                value,
                              );
                              methods.trigger();
                              handleValueChanges();
                              if (!isValid) {
                                methods.setError(
                                  `users.${index}.iac_aw_phone`,
                                  {
                                    type: "manual",
                                    message: e.target.guide,
                                  },
                                );
                              } else {
                                methods.clearErrors(
                                  `users.${index}.iac_aw_phone`,
                                );
                              }
                            }}

                            selectedCountry={
                              methods.watch(
                                `users.${index}.iac_aw_phone_country`,
                              ) || "US"
                            }
                            placeholder="1 (212) 313-2123"
                            value={methods.watch(`users.${index}.iac_aw_phone`)}
                          />
                        </div>
                        <div i2c-grid="4@md">
                          <I2cPhoneField
                            format="NATIONAL"
                            show-flags
                            name="iac_aw_cell"
                            label="Cell Number"
                            size="large"
                            country-box
                            key={user.id} // important to include key with field's id
                            onI2cChange={(e) => {
                              const country = e.target.country;
                              const isValid = e.target.isValid;
                              const value = e.target.value;
                              methods.setValue(
                                `users.${index}.iac_aw_cell_country`,
                                country,
                              );
                              methods.setValue(
                                `users.${index}.iac_aw_cell`,
                                value,
                              );
                              methods.trigger();
                              handleValueChanges();
                              if (!isValid) {
                                methods.setError(`users.${index}.iac_aw_cell`, {
                                  type: "manual",
                                  message: e.target.guide,
                                });
                              } else {
                                methods.clearErrors(
                                  `users.${index}.iac_aw_cell`,
                                );
                              }
                            }}

                            selectedCountry={
                              methods.watch(
                                `users.${index}.iac_aw_cell_country`,
                              ) || "US"
                            }
                            placeholder="1 (212) 313-2123"
                            value={methods.watch(`users.${index}.iac_aw_cell`)}
                          />
                        </div>

                        <div i2c-grid="4@md">
                          <Controller
                            name={"iac_aw_email" + index}
                            control={control}
                            render={({ field }) => (
                              <I2cInput
                                {...field}
                                label="Email"
                                placeholder="Enter email"
                                name={"iac_aw_name" + index}
                                size="large"
                                value={
                                  methods.watch(`users`)[index]?.iac_aw_email
                                }

                                type="email"
                                key={user.id} // important to include key with field's id
                                onI2cInput={(e) => {
                                  methods.setValue(
                                    `users.${index}.iac_aw_email`,
                                    e.target.value,
                                  );
                                  methods.trigger();
                                  handleValueChanges();
                                }}
                              />
                            )}
                          />
                          {/* {errors?.users?.length &&
                          methods.formState.touchedFields ? (
                            <ErrorMessage
                              show={
                                errors.users[index]?.iac_aw_email &&
                                methods.formState.touchedFields?.[
                                  "iac_aw_email" + index
                                ]
                                  ? true
                                  : false
                              }
                              message={
                                errors?.users[index]?.iac_aw_email?.message ??
                                "Invalid input"
                              }
                            />
                          ) : null} */}
                        </div>
                        <div i2c-grid="12">
                          {index > 0 && (
                            <I2cButton
                              onClick={() => {
                                const filteredData = fields.filter(
                                  (user, ind) => ind !== index,
                                );
                                remove(index);
                                methods.setValue("users", filteredData);
                                setActiveTab(index - 1);
                                methods.trigger();
                                handleValueChanges();
                              }}
                              destructive
                              variant="secondary gray"
                            >
                              Delete
                            </I2cButton>
                          )}
                        </div>
                      </div>
                    </I2cTabPanel>
                  </React.Fragment>
                ))}
                <I2cButton
                slot="nav"
                className="add-user-button"
                variant="tertiary gray"
                disabled={fields.length === 5}
                onClick={() => {
                  append({
                    iac_aw_name: "",
                    iac_aw_title: "",
                    iac_aw_phone: "",
                    iac_aw_phone_country: "",
                    iac_aw_cell: "",
                    iac_aw_cell_country: "",
                    iac_aw_email: "",
                  });
                  setActiveTab(fields.length);
                }}
              >
                <I2cIcon
                  name="linear-add"
                  label="placeholder"
                  slot="prefix"
                ></I2cIcon>
                Add More
              </I2cButton>
              </I2cTabGroup>
              
            </div>
              
          </>
        )}
      </div>
    </React.Fragment>
  );
};

export default CustomerServiceWebsite;
